import React, { useEffect, useState } from 'react';
import { FieldArray } from 'formik';
import { Grid, Header, Table, Button, Pagination, Input } from 'semantic-ui-react';
import { Checkbox } from 'formik-semantic-ui';
import moment from 'moment';
import PoDetails from './modals/poDetails';
import ReadAxios from '../../../axiosComponent/read';
import LoadingPlaceholder from '../../../placeholderComponent/loadingPlaceholder';

const ActivePurchaseOrder = ({ editmode, viewmode, masterState, vendorStateId, updatePurchaseOrder, refreshedOrder, masterBranch, orderDetails, handlePaginationChangeAPI, totalPagesPresentProp, currentPageNoProp, handleSearchString, searchTextProps }) => {

    const [currentPageNo, setCurrentPageNo] = useState(currentPageNoProp);
    const [totalPagesPresent, setTotalPagesPresent] = useState(totalPagesPresentProp);

    const [searchText, setSearchText] = useState(searchTextProps);



    useEffect(() => {
        setCurrentPageNo(currentPageNoProp)
        setTotalPagesPresent(totalPagesPresentProp)
        setSearchText(searchTextProps)
    }, []);


    let handleRefresh = (data) => {
        if (data) {
            refreshedOrder(data)
        }
    }

    let handlePaginationChange = (e, { activePage }) => {
        handlePaginationChangeAPI(activePage)
    }

    let searchString = (e) => {
        if (e.keyCode == 13) {
            handleSearchString(e.target.value)
        }
    }


    return (
        <div className="ui form">
            <FieldArray
                name="activePODetails">
                {({ push, remove, form }) => {

                    const { inititalValues, values } = form
                    const { activePODetails, productDetails, manualPoAddedTotal, activePOSelected } = values
                    let tempPoAmount = []
                    let selectedPO = []

                    activePODetails.length > 0 && activePODetails.filter((item) => {
                        if (item.checkbox === true) {
                            if (values.isGstApplicable) {
                                tempPoAmount.push(item.poAmount)
                                selectedPO.push(item)
                            } else {
                                tempPoAmount.push(item.taxableAmount)
                                selectedPO.push(item)
                            }
                        }
                    })


                    if (editmode == true) {
                        values.activePoAddedTotal = tempPoAmount.reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0).toFixed(2)
                    } else {
                        values.activePoAddedTotal = tempPoAmount.reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0).toFixed(2)
                        values.finalAmount = +manualPoAddedTotal + +values.activePoAddedTotal
                    }

                    values.activePOSelected = selectedPO

                    return (
                        <>
                            <div class="ui focus input pb-2" style={{ float: 'right' }}>
                                <input type="text" defaultValue={searchText} placeholder="Search Purchase Order Number	..." onKeyUp={searchString} />
                            </div>

                            <Table unstackable size="large" compact="very" className="w3-small">
                                <Table.Header>
                                    <Table.Row >
                                        {viewmode ? "" : <Table.HeaderCell className="labelName p-bold-600"></Table.HeaderCell>}
                                        <Table.HeaderCell className="labelName p-bold-600">Order Number</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Purchase Order Number</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Order Date</Table.HeaderCell>
                                        {/* <Table.HeaderCell className="labelName p-bold-600">LR No.</Table.HeaderCell> */}
                                        <Table.HeaderCell className="labelName p-bold-600">LR No.</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Delivery Date</Table.HeaderCell>
                                        {/* <Table.HeaderCell className="labelName p-bold-600">TDS Amount</Table.HeaderCell> */}
                                        <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Remarks</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {activePODetails.length > 0 ?
                                        activePODetails.map((object, index) => {
                                            return (
                                                <Table.Row verticalAlign="middle">
                                                    <React.Fragment>
                                                        {viewmode ?
                                                            ""
                                                            :
                                                            <>
                                                                {
                                                                    (object?.delivery_status?.delivery_code && (object.delivery_status.delivery_code == 'DLVRD' || object.delivery_status.delivery_code == 'UNLOADING-DELIVER' || object.delivery_status.delivery_code == 'UNLOADING-GATEOUT')) ?
                                                                        <Table.Cell>
                                                                            <Checkbox
                                                                                name={`activePODetails[${index}].checkbox`}
                                                                                value={activePODetails[index].checkbox}
                                                                                inputProps={{ disabled: object.delivery_status && (object.delivery_status.delivery_code == 'DLVRD' || object.delivery_status.delivery_code == 'UNLOADING-DELIVER' || object.delivery_status.delivery_code == 'UNLOADING-GATEOUT') ? false : true }}
                                                                            // disabled={true}
                                                                            />
                                                                        </Table.Cell>
                                                                        :
                                                                        <Table.Cell></Table.Cell>
                                                                }
                                                            </>
                                                        }

                                                        <Table.Cell>
                                                            {activePODetails[index].order_reference_no}
                                                            <PoDetails
                                                                poId={activePODetails[index].poId}
                                                                masterState={masterState}
                                                                refreshOrders={handleRefresh}
                                                                masterBranch={masterBranch}
                                                                vendorStateId={vendorStateId}
                                                                isGstApplicable={values.isGstApplicable}
                                                                updatePurchaseOrder={updatePurchaseOrder}
                                                                formValues={values}
                                                                viewmode={viewmode}
                                                            />
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {activePODetails[index].poNumber ? activePODetails[index].poNumber : "N/A"}
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {activePODetails[index].order_date ? activePODetails[index].order_date : "N/A"}
                                                        </Table.Cell>
                                                        {/* <Table.Cell>
                                                            {activePODetails[index].lr_no}
                                                        </Table.Cell> */}
                                                        <Table.Cell>
                                                            {activePODetails[index].vendor_lr_no ? activePODetails[index].vendor_lr_no : 'N/A'}
                                                        </Table.Cell>
                                                        <Table.Cell >
                                                            {activePODetails[index].deliveryDate ? moment(activePODetails[index].deliveryDate).format("DD-MM-YYYY") : 'N/A'}
                                                        </Table.Cell>
                                                        {/* <Table.Cell>
                                                            {activePODetails[index].tdsAmount}
                                                        </Table.Cell> */}
                                                        <Table.Cell>
                                                            {values.isGstApplicable ? activePODetails[index].poAmount : activePODetails[index].taxableAmount}
                                                        </Table.Cell>
                                                        <Table.Cell >
                                                            {(activePODetails?.[index]?.remarksList && activePODetails?.[index]?.remarksList.length > 0) ? activePODetails[index].remarksList.join(', ') : '-'}
                                                        </Table.Cell>
                                                    </React.Fragment>
                                                </Table.Row>
                                            )
                                        }
                                        ) :
                                        <>
                                            <LoadingPlaceholder />
                                        </>
                                    }
                                </Table.Body>
                            </Table>
                            <Grid columns={3}>
                                <Grid.Row className="p-2">
                                    <Grid.Column width={10} />
                                    <Grid.Column>

                                        {viewmode ? "" :
                                            <Grid.Row>
                                                <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Total</Header>
                                                <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.activePoAddedTotal}</Header>
                                            </Grid.Row>}

                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                            <div className="life-cycle w3-white p-2 mt-9">
                                <Pagination
                                    defaultActivePage={currentPageNo}
                                    firstItem={null}
                                    lastItem={null}
                                    onPageChange={handlePaginationChange}
                                    pointing
                                    secondary
                                    totalPages={totalPagesPresent}
                                />
                            </div>
                        </>
                    )
                }
                }
            </FieldArray>
        </div>
    )
}

export default ActivePurchaseOrder



